module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "a01_uthor"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("ARTHUR J MARDER was a meticulous researcher, teacher and writer who, born in 1910, was to become perhaps the most distinguished historian of the modern Royal Navy. He held a number of teaching posts in American universities and was to receive countless honours, as well as publish some fifteen major works on British naval history. He died in 1980.")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("BARRY GOUGH, the distinguished Canadian maritime and naval historian, is the author of "), _c('i', [_vm._v("Historical Dreadnoughts: Arthur Marder, Stephen Roskill and the Battles for Naval History")]), _vm._v(", recently published by Seaforth Publishing.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p0-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fgcaption"
  }, [_c('a', {
    attrs: {
      "id": "uthf1"
    }
  }), _vm._v("ADMIRAL SIR JOHN JELLICOE")]), _vm._v(" "), _c('p', {
    staticClass: "fgcaptiona"
  }, [_vm._v("Commander-in-Chief, Grand Fleet, 1914–16")]), _vm._v(" "), _c('p', {
    staticClass: "fgcaptionb"
  }, [_c('i', [_vm._v("[Photograph : Radio Times Hulton Picture Library")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c4448636","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/01_uthor.vue
// module id = 57
// module chunks = 0